import * as React from "react";
import { App } from "./app";
import { ArticleOrderGW } from "./ArticleOrderGW";
import { ArticleGW } from "./ArticleGW";
import { Assert } from "./PADebug";

/* ExtDataGW holds extended info for an article, mainly to be displayed in the extended info for a selected article.
 * The life of an ExtDataGW instance begins when an article item is selected and an extended info view is opened for it,
 * then it dies again if no amount is given to the article, if however an amount is added, the ExtInfoGW is added and becomes
 * permanently attatched to the article, until that same article is removed from the selected items array by clicking the
 * cross button for this article in the quick report, reducing the amounts to 0 won't kill the attatched ExtDataGW object.
 * ExtDataGW gets its extended data from back end on request, and may contain larger data like a description, additional
 * information or loaded product images. */

export class ExtDataGW {

    constructor() {
        this.m_nobbNr = 0
        this.m_nobbModulNr = 0
        this.m_varetype = 0
        this.m_vareTekst1 = ""
        this.m_vareTekst2 = ""
        this.m_langVaretekst = ""
        this.m_produsentVareNr = ""
        this.m_lagerfort = false
        this.m_varebeskrivelse = ""
        this.m_valgtLeverantorIndex = 0
        this.m_hoveredLeverantorIndex = -1
        this.m_valgtPakkeIndex = 0
        this.m_hoveredPakkeIndex = -1
        this.m_valgtDimIndex = 0
        this.m_activePakkeIndex = 0
        this.m_hoveredDimIndex = -1
        this.m_hoveredMediaLink = -1
        this.m_hoveredProductImage = false
        this.m_fpakUnitId = "(ukjent)"
        this.m_fpakUnitDescription = "(ukjent)"
        this.m_fpakUnitFull = "(ukjent)"
        this.m_isDefaultDataForArticlesMissingNobbNumber = false
        this.m_selectionLabel = "Label not set"
    }
    
    // Returns a string which is unique for the related article and which will be compared to tell if this extdata belongs to it or not
    public GetSelectionLabel() {
        return this.m_selectionLabel
    }

    // Sets the selection label
    public SetSelectionLabel(selectionLabel:string) {
        this.m_selectionLabel = selectionLabel
    }
    
    GetFpakUnit(article : ArticleGW) {
        if (this.m_leverandorer == undefined) {
            Assert(false, "ExtData.GetFpakUnit() - m_leverandorer is undefined.")
            return
        }

        var unit = article.GetUnit()
        var least = null

        const leverandor = this.m_leverandorer[this.m_valgtLeverantorIndex]

        for (var pak = 0; pak < leverandor.pakninger.length; pak++) {
            if (leverandor.pakninger[pak].pakningKlasse & 1) {
                const pakning = leverandor.pakninger[pak]

                if (least == null) {
                    least = pakning.kalkulertInnhold
                    unit = pakning.pakningsEnhet.id

                    this.m_fpakUnitFull = pakning.pakningsEnhet.beskrivelse + " (" + pakning.pakningsEnhet.id + ")"
                    this.m_fpakUnitDescription = pakning.pakningsEnhet.beskrivelse
                    this.m_fpakUnitId = pakning.pakningsEnhet.id
                }
                else {
                    if (least > pakning.kalkulertInnhold) {
                        least = pakning.kalkulertInnhold
                        unit = pakning.pakningsEnhet.id

                        this.m_fpakUnitFull = pakning.pakningsEnhet.beskrivelse + " (" + pakning.pakningsEnhet.id + ")"
                        this.m_fpakUnitDescription = pakning.pakningsEnhet.beskrivelse
                        this.m_fpakUnitId = pakning.pakningsEnhet.id
                    }
                }
            }
        }

        return unit
    }
    
    // Takes in data from the backend and fills this ExtData with content
    RecieveData(data: any) {

        // Some primary recieved data will be added if existant, or initiated by defaults
        this.m_nobbNr = (data.nobbNr != null) ? data.nobbNr : 0 
        this.m_nobbModulNr = (data.nobbModulNr != null) ? data.nobbModulNr : 0
        this.m_varetype = (data.varetype != null) ? data.varetype : 0
        this.m_vareTekst1 = (data.vareTekst1 != null) ? data.vareTekst1 : ""
        this.m_vareTekst2 = (data.vareTekst2 != null) ? data.vareTekst2 : ""
        this.m_langVaretekst = (data.langVaretekst != null) ? data.langVaretekst : ""
        this.m_produsentVareNr = (data.produsentVareNr != null) ? data.produsentVareNr : ""
        this.m_lagerfort = (data.lagerfort != null) ? data.lagerfort : false
        this.m_prisEnhet = (data.prisEnhet != null) ? data.prisEnhet : false
        this.m_varebeskrivelse = (data.varebeskrivelse != null) ? data.varebeskrivelse : ""
        this.m_valgtLeverantorIndex = 0
        this.m_hoveredLeverantorIndex = -1
        this.m_valgtPakkeIndex = 0
        this.m_hoveredPakkeIndex = -1
        this.m_valgtDimIndex = 0
        this.m_hoveredDimIndex = -1
        this.m_hoveredMediaLink = -1
        this.m_hoveredProductImage = false

        // leverantake holds the suppliers array and their underlying data, some changes will be done to this before it's applied...
        var leverantake: [{
            deltagerNr: string,
            navn: string,
            erVareeier: boolean,
            vareNummer: string,
            
            pakninger: [{
                amount: number,
                pakningNr: number,
                pakningKlasse: number,

                pakningsEnhet: {
                    id: string,
                    beskrivelse: string
                },

                erPrisEnhet: boolean,
                erPSE: boolean,
                kalkulertInnhold: number,

                bestarAv: {
                    antall: number,

                    enhet: {
                        id: string,
                        beskrivelse: string
                    }
                },

                gtin: string,
                gtinType: number,

                pakningsMal: [{
                    bredde: number,
                    lengde: number,
                    hoyde: number,
                    vekt: number,
                    volum: number,
                    type: number
                }] | null,

                lagerfort: boolean,
                bestillbar: boolean
            }]

            medier: [{
                mediaType: string,
                url: string
            }]

        }] = data.leverandorer

        // Initiates the amounts for each package type to zero
        for (var i = 0, j; i < leverantake.length; i++) {
            for (j = 0; j < leverantake[i].pakninger.length; j++){
                leverantake[i].pakninger[j].amount = 0
            }
        }

        this.m_leverandorer = leverantake
        this.m_vareGruppeNr = data.vareGruppeNr
    }

    // 
    GetNumberFromNobbString(nobb: string) {
        var value = 0
        var pot = 1

        for (var i = nobb.length - 1; i >= 0; i-- , pot *= 10) {
            if (nobb.charAt(i) == "0") {
                continue
            }

            if (nobb.charAt(i) == "1") {
                value += 1*pot
                continue
            }

            if (nobb.charAt(i) == "2") {
                value += 2 * pot
                continue
            }

            if (nobb.charAt(i) == "3") {
                value += 3 * pot
                continue
            }

            if (nobb.charAt(i) == "4") {
                value += 4 * pot
                continue
            }

            if (nobb.charAt(i) == "5") {
                value += 5 * pot
                continue
            }

            if (nobb.charAt(i) == "6") {
                value += 6 * pot
                continue
            }

            if (nobb.charAt(i) == "7") {
                value += 7 * pot
                continue
            }

            if (nobb.charAt(i) == "8") {
                value += 8 * pot
                continue
            }

            if (nobb.charAt(i) == "9") {
                value += 9 * pot
                continue
            }

            // Failure, this string contained more than just numbers!
            alert("Error in ExtDataGW.GetNumberFromNobbString - ")
        }

        return value
    }

    // Produces an array of article orders based on the amount choises made for the associated article
    GetArticleOrders(articleReference: ArticleGW) {
        var orders = new Array<ArticleOrderGW>()

        const lev = this.GetLeverandorer()

        if (lev == undefined) {
            // This means the ExtData is the default, for articles missing it, so we will only use the article itself
            // for generating one single order..

            const currentOrder = new ArticleOrderGW()
            currentOrder.SetAmount(articleReference.GetAmount())
            currentOrder.SetSupplierName(articleReference.GetSupplier())
            currentOrder.SetSupplierId(articleReference.GetSupplyIdentifier())
            currentOrder.SetUnit(articleReference.GetUnit())
            currentOrder.SetUnitId(articleReference.GetUnit())
            currentOrder.SetNobb(this.GetNumberFromNobbString(articleReference.GetNobb()))
            currentOrder.SetArticle(articleReference)
            currentOrder.SetPackageUnits(1.0)
            currentOrder.SetPriceBook(articleReference.GetPriceBook())
            currentOrder.SetOrderingId(articleReference.GetIdentifier())

            orders.push(currentOrder)
        }
        else {
            for (var suppl = 0; suppl < lev.length; suppl++) {
                for (var unit = 0; unit < lev[suppl].pakninger.length; unit++) {
                    if ((suppl != 0) || (unit != 0)) {
                        if (lev[suppl].pakninger[unit].amount == 0) {
                            continue
                            // The first supplier and first package type is always going to be added, even if it has 0 as amount,
                            // because this way it will be possible to save articles regardless of their amounts, as when storing favorites
                            // or selections where the amount was chosen to be 0 by the user who then decided not to use the x button to remove it
                            // from the list of selections.
                        }
                    }
                     
                    const currentOrder = new ArticleOrderGW()
                    currentOrder.SetAmount(lev[suppl].pakninger[unit].amount)
                    currentOrder.SetSupplierName(lev[suppl].navn)
                    currentOrder.SetSupplierId(lev[suppl].deltagerNr)
                    currentOrder.SetUnit(lev[suppl].pakninger[unit].pakningsEnhet.beskrivelse)
                    currentOrder.SetUnitId(lev[suppl].pakninger[unit].pakningsEnhet.id)
                    currentOrder.SetNobb(this.GetNobbNr())
                    currentOrder.SetArticle(articleReference)
                    currentOrder.SetPackageUnits(lev[suppl].pakninger[unit].kalkulertInnhold)
                    currentOrder.SetPriceBook(articleReference.GetPriceBook())
                    currentOrder.SetOrderingId(articleReference.GetIdentifier())
                     
                    orders.push(currentOrder)
                }
            }
        }
        
        return orders
    }

    GetFpakProportion(article : ArticleGW) {
        if (this.m_leverandorer == undefined) {
            Assert(false, "ExtData.GetFpakProportion() - m_leverandorer is undefined.")
            return null
        }

        const fpakUnit = this.GetFpakUnit(article)
        const unitAmount = this.GetUnitCalculatedAmount()

        if (unitAmount == undefined) {
            alert("Error: ExtDataGW.GetFpakProportion - examined article has default ext data (=is missing the real thing)")
            return null// Looks like this is the defult ext data for articles missing it.
        }

        var pakker = this.GetLeverandorer()[this.GetValgtLeverantorIndex()].pakninger
        var valgtPakke = pakker[this.GetValgtPakkeIndex()]
        var proportion = 1.0

        for (var i = 0; i < pakker.length; i++) {
            if (pakker[i].pakningsEnhet.id == fpakUnit) {
                if (unitAmount != 0) {
                    proportion = pakker[i].kalkulertInnhold / unitAmount
                    break
                }
            }
        }

        return proportion
    }

    // Translates the amount (price unit) into an anount of the FPAK unit (lessest package unit) and return an article order with that amount in it
    GetFpakOrder(stage: number, flags: number, articleReference: ArticleGW, roundUp: boolean) {

        if (this.m_leverandorer == undefined) {
            Assert(false, "ExtData.GetFpakOrder() - m_leverandorer is undefined.")
            return
        }

        const depaultPackage = this.m_leverandorer[this.GetValgtLeverantorIndex()].pakninger[this.GetValgtPakkeIndex()]
        var fpakPackage = depaultPackage
        const FpakId = this.GetFpakUnit(articleReference)
        
        var suppl = this.GetValgtLeverantorIndex()
        var unit = this.GetValgtPakkeIndex()

        for (var pak = 0; pak < this.m_leverandorer[suppl].pakninger.length; pak++) {
            if ((this.m_leverandorer[suppl].pakninger[pak].bestillbar == true) && (this.m_leverandorer[suppl].pakninger[pak].pakningsEnhet.id == FpakId)) {
                fpakPackage = this.m_leverandorer[suppl].pakninger[pak]
                unit = pak
            }
        }

        var pricedAmount = depaultPackage.kalkulertInnhold * depaultPackage.amount
        var fpakAmount = pricedAmount / fpakPackage.kalkulertInnhold

        if (roundUp == true) {
            var fract = fpakAmount % 1
            if (fract != 0) {
                fpakAmount -= fract
                fpakAmount++
            }
        }

        const order = new ArticleOrderGW()
        order.SetRenderingMode(stage, flags)
        order.SetAmount(fpakAmount)
        order.SetSupplierName(this.GetLeverandorer()[suppl].navn)
        order.SetSupplierId(this.GetLeverandorer()[suppl].deltagerNr)
        order.SetUnit(this.GetLeverandorer()[suppl].pakninger[unit].pakningsEnhet.beskrivelse)
        order.SetUnitId(this.GetLeverandorer()[suppl].pakninger[unit].pakningsEnhet.id)
        order.SetNobb(this.GetNobbNr())
        order.SetArticle(articleReference)
        order.SetPackageUnits(this.GetLeverandorer()[suppl].pakninger[unit].kalkulertInnhold)
        order.SetPriceBook(articleReference.GetPriceBook())
        order.SetOrderingId(articleReference.GetIdentifier())
        
        return order
    }

    // An alternate order without conversion into FPAK or any rounding up being performed, but showing the amount in original price unit
    GetOrder(stage: number, flags: number, articleReference: ArticleGW) {
        if (this.m_leverandorer == undefined) {
            Assert(false, "ExtData.GetOrder() - m_leverandorer is undefined.")
            return
        }

        var suppl = this.GetValgtLeverantorIndex()
        var unit = this.GetValgtPakkeIndex()
        const depaultPackage = this.m_leverandorer[suppl].pakninger[unit]
        const order = new ArticleOrderGW()
        order.SetRenderingMode(stage, flags)

        order.SetAmount(depaultPackage.amount)
        order.SetSupplierName(this.GetLeverandorer()[suppl].navn)
        order.SetSupplierId(this.GetLeverandorer()[suppl].deltagerNr)
        order.SetUnit(this.GetLeverandorer()[suppl].pakninger[unit].pakningsEnhet.beskrivelse)
        order.SetUnitId(this.GetLeverandorer()[suppl].pakninger[unit].pakningsEnhet.id)
        order.SetNobb(this.GetNobbNr())
        order.SetArticle(articleReference)
        order.SetPackageUnits(this.GetLeverandorer()[suppl].pakninger[unit].kalkulertInnhold)
        order.SetPriceBook(articleReference.GetPriceBook())
        order.SetOrderingId(articleReference.GetIdentifier())

        return order
    }

    public GetTotalWeight() {
        var inholdSum = 0
        var unweightedMass = 0

        for (var lev = 0; lev < this.m_leverandorer.length; lev++) {
            for (var pak = 0; pak < this.m_leverandorer[lev].pakninger.length; pak++) {
                if (this.m_leverandorer[lev].pakninger[pak].amount > 0) {
                    if ((this.m_leverandorer[lev].pakninger[pak].kalkulertInnhold != null) && (this.m_leverandorer[lev].pakninger[pak].amount != null) && (this.m_leverandorer[lev].pakninger[pak].pakningsMal != null)) {
                        var mal = this.m_leverandorer[lev].pakninger[pak].pakningsMal

                        if (mal) {
                            for (var m = 0; m < mal.length; m++) {
                                if (mal[m].vekt != null) {
                                    inholdSum += mal[m].vekt * this.m_leverandorer[lev].pakninger[pak].amount
                                    // Breaking this loop at the first found weight value is done because of how this data structure is 
                                    // designed and used. The amount is not given specificly for each measurements version of the same package, so it cannot
                                    // be calculated for more than one version anyway, and practically, the suppliers have either provided no measurements
                                    // for their product or one set of measurements on one or more available package types, which is correct use. In the possible
                                    // case where more measurement versions within the same package type would be given, the first valid one is simply picked and used,
                                    // and this is basically an error made by that supplier or the system in use who/which should better define separate package types and 
                                    // give those different measurements for each one to be selectable and given separate amounts and like in this case - a separate weight.
                                    // I have so far never came acoss any such missuse, it is a flaw in how this data was structured by nobb that could potentially lead
                                    // to technical errors, but won't lead to any such errors here as the structural flaw has been taken into account.
                                    break
                                }
                            }
                        }
                    }
                    else {
                        // Some data is not given here, but maybe the weight can still be calculated from information found elsewhere...

                        if ((this.m_leverandorer[lev].pakninger[pak].kalkulertInnhold != null) && (this.m_leverandorer[lev].pakninger[pak].amount != null)) {
                            // we know enough to compare this amount with another package type that has weight data provided 

                            var foundMass = this.m_leverandorer[lev].pakninger[pak].kalkulertInnhold * this.m_leverandorer[lev].pakninger[pak].amount

                            if (foundMass > 0) {
                                unweightedMass += foundMass // the mass is simply summed up here and will be translated into weight afterwards
                            }
                        }
                    }
                }
            }
        }

        // For as long as there are an amount of this article that has no provided weight data, a search will continue for any weight info for this article
        // to compare with and then still produce the answer to how much the amount of this less defined package should weight, then return that answer.
        for (var lev = 0; (lev < this.m_leverandorer.length) && (unweightedMass > 0); lev++) {
            for (var pak = 0; (pak < this.m_leverandorer[lev].pakninger.length) && (unweightedMass > 0) ; pak++) {
                if (this.m_leverandorer[lev].pakninger[pak].pakningsMal != null) {
                    var mal = this.m_leverandorer[lev].pakninger[pak].pakningsMal

                    if (mal) {
                        for (var m = 0; m < mal.length; m++) {
                            if (mal[m].vekt != null) {

                                if ((this.m_leverandorer[lev].pakninger[pak].amount != null) && (this.m_leverandorer[lev].pakninger[pak].kalkulertInnhold != null)) {

                                    if (this.m_leverandorer[lev].pakninger[pak].kalkulertInnhold > 0) { // innhold must not be 0 as that would result in a division with 0 and thus infinity as a result
                                        inholdSum += mal[m].vekt * (unweightedMass / this.m_leverandorer[lev].pakninger[pak].kalkulertInnhold)
                                        unweightedMass = 0 // this will end the search at once
                                        break
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        if (unweightedMass > 0) {
            // We have come across an article that has no weight data provided, has no other package types with weight data to compare with and no other suppliers
            // who has taken the time to enter weight data for this product, so basically this article has no weight data. This will be logged to the debug output.

            Assert(false, "ExtDataGW.GetTotalWeight - no weight data was to be found for nobb : " + this.m_nobbNr.toString() )
        }
        
        return inholdSum
    }

    public GetUnitCalculatedAmount() {
        if (this.m_leverandorer == undefined) {
            Assert(false, "ExtData.GetUnitCalculatedAmount() - m_leverandorer is undefined.")
            return
        }

        return this.m_leverandorer[this.m_valgtLeverantorIndex].pakninger[this.m_valgtPakkeIndex].kalkulertInnhold
    }
    
    public GetSumA() {
        if (this.m_leverandorer == undefined) {
            Assert(false, "ExtData.GetSum() - m_leverandorer is undefined.")
            return
        }
        
        var sum = 0

        for (var i = 0, j; i < this.m_leverandorer.length; i++) {
            for (j = 0; j < this.m_leverandorer[i].pakninger.length; j++) {
                sum += (this.m_leverandorer[i].pakninger[j].kalkulertInnhold * this.m_leverandorer[i].pakninger[j].amount)
            }
        }

        return sum
    }

    public GetAmount() {
        if (this.m_leverandorer == undefined) {
            Assert(false, "ExtData.GetAmount() - m_leverandorer is undefined.")
            return
        }

        return this.m_leverandorer[this.m_valgtLeverantorIndex].pakninger[this.m_valgtPakkeIndex].amount
    }

    public GetAmountHidden() {
        if (this.m_leverandorer == undefined) {
            Assert(false, "ExtData.GetAmountHidden() - m_leverandorer is undefined.")
            return
        }

        for (var i = 0, j; i < this.m_leverandorer.length; i++) {
            for (j = 0; j < this.m_leverandorer[i].pakninger.length; j++) {
                if ((i == this.m_valgtLeverantorIndex) && (j == this.m_valgtPakkeIndex)) {
                    continue
                }

                if (this.m_leverandorer[i].pakninger[j].amount != 0) {
                    return true
                }
            }
        }

        return false
    }
    
    public SetAmount(newAmount: number) {
        if (this.m_leverandorer == undefined) {
            Assert(false, "ExtData.SetAmount() - m_leverandorer is undefined.")
            return
        }

        this.m_leverandorer[this.m_valgtLeverantorIndex].pakninger[this.m_valgtPakkeIndex].amount = newAmount
    }

    /* GetHeightFactor calculates the amount of rows that will be needed in the supplier & package selection field, which
     * then will be used to control the height of that window so that all contents will have their required space. */
    public GetRadioHeight() {
        if (this.m_leverandorer == undefined) {
            Assert(false, "ExtData.GetRadioHeight() - m_leverandorer is undefined.")
            return -1
        }
        
        if (this.m_leverandorer == null) {
            alert("Error: Missing suppliers (given by a request to back end) on ExtDataGW:GetHeightFactor()")
            return 10; // (Just avoiding a potential null pointer exception, which shouldn't happen if the data is good.)
        }
        
        const rowHeight = 20
        const mediaLinkHeight = 20
        const mediaTitleHeight = 34
        const margin = 5
        const separatorHeight = 8

        const minimum = 2 * rowHeight // 'minimum' can be changed as mere cosmetics, it sets a general minimum amount of rows to this value
        var greatest = (minimum < (this.m_leverandorer.length * rowHeight)) ? (this.m_leverandorer.length * rowHeight) : minimum

        // LinkHeight is how much height is added by the extension of the unit section, for the media links (if existant)
        var linkHeight = 0
        if (this.GetLeverandorer()[this.GetValgtLeverantorIndex()].medier != null) {
            if (this.GetLeverandorer()[this.GetValgtLeverantorIndex()].medier.length > 0) {
                linkHeight = (this.GetLeverandorer()[this.GetValgtLeverantorIndex()].medier.length * mediaLinkHeight) + mediaTitleHeight
            }
        }

        // compares to the amount of units available for this article
        if ((this.m_leverandorer[this.m_valgtLeverantorIndex].pakninger.length * rowHeight) + linkHeight > greatest) {
            greatest = (this.m_leverandorer[this.m_valgtLeverantorIndex].pakninger.length * rowHeight) + linkHeight
        }

        var mal = this.m_leverandorer[this.m_valgtLeverantorIndex].pakninger[this.m_valgtPakkeIndex].pakningsMal

        if (mal != null) {
            // Let's first find out if the existant array is empty 
            if (mal.length == 0) {
            }

            // Now let's check what specs actually have a value, and reserve space only for those...
            var specs = 0

            // bredde
            if (mal[this.m_valgtDimIndex].bredde != null) {
                specs++
            }

            // høyde
            if (mal[this.m_valgtDimIndex].hoyde != null) {
                specs++
            }

            // lengde
            if (mal[this.m_valgtDimIndex].lengde != null) {
                specs++
            }

            // type
            if (mal[this.m_valgtDimIndex].type != null) {
                specs++
            }

            // vekt
            if (mal[this.m_valgtDimIndex].vekt != null) {
                specs++
            }

            // volum
            if (mal[this.m_valgtDimIndex].volum != null) {
                specs++
            }

            // Now specs holds the amount of rows needed except for the array of selectable dimensions displayed above, so let's put it together... 
            const dimensionHeight = ((mal.length + specs + 2) * rowHeight) + separatorHeight // +2 for the 'in storage' and 'orderable' flags in the end

            if (dimensionHeight > greatest) {
                greatest = dimensionHeight
            }
        }
        else {
            // pakningsmal is null, meaning dimensions won't be shown at all so its height need not to be taken into account, but the two flags and separation line might still take up some space
            if (2 * rowHeight > greatest) {
                greatest = 2 * rowHeight
            }
        }

        return greatest + margin
    }

    // Access to NobbNr
    GetNobbNr() {
        return this.m_nobbNr
    }

    // Access to nobbNr
    SetNobbNr( nr:number ){
        this.m_nobbNr = nr
    }

    // Access to nobbModulNr
    GetNobbModulNr() {
        return this.m_nobbModulNr
    }

    // Access to nobbModulNr
    SetNobbModulNr(nr: number) {
        this.m_nobbModulNr = nr
    }

    // Access to valgtLeverantorIndex
    SetValgtLeverantorIndex(lev: number) {
        this.m_valgtLeverantorIndex = lev
    }

    // Access to valgtLeverantorIndex
    GetValgtLeverantorIndex() {
        return this.m_valgtLeverantorIndex
    }

    // Access to hoveredLeverantorIndex
    SetHoveredLeverantorIndex(lev: number) {
        this.m_hoveredLeverantorIndex = lev
    }

    // Access to hoveredLeverantorIndex
    GetHoveredLeverantorIndex() {
        return this.m_hoveredLeverantorIndex
    }

    // Access to valgtPakkeIndex
    SetValgtPakkeIndex(pak: number) {
        this.m_valgtPakkeIndex = pak
    }

    // Access to valgtPakkeIndex
    GetValgtPakkeIndex() {
        return this.m_valgtPakkeIndex
    }

    // Access to valgtPakkeIndex
    SetActivePakkeIndex(pak: number) {
        this.m_activePakkeIndex = pak
    }

    // Access to valgtPakkeIndex
    GetActivePakkeIndex() {
        return this.m_activePakkeIndex
    }
    
    // Access to hoveredPakkeIndex
    SetHoveredPakkeIndex(pak: number) {
        this.m_hoveredPakkeIndex = pak
    }

    // Access to hoveredPakkeIndex
    GetHoveredPakkeIndex() {
        return this.m_hoveredPakkeIndex
    }

    // Access to m_hoveredMediaLink
    GetHoveredMediaLink() {
        return this.m_hoveredMediaLink
    }

    // Access to m_hoveredMediaLink
    SetHoveredMediaLink(index : number) {
        this.m_hoveredMediaLink = index
    }

    // Access to m_hoveredProductImage
    SetHoveredProductImage(status: boolean) {
        this.m_hoveredProductImage = status
    }

    // Access to m_hoveredProductImage
    GetHoveredProductImage() {
        return this.m_hoveredProductImage
    }

    // Access to valgtDimIndex
    SetValgtDimIndex(dim: number) {
        this.m_valgtDimIndex = dim
    }

    // Access to valgtDimIndex
    GetValgtDimIndex() {
        return this.m_valgtDimIndex
    }

    // Access to hoveredDimIndex
    SetHoveredDimIndex(dim: number) {
        this.m_hoveredDimIndex = dim
    }

    // Access to hoveredDimIndex
    GetHoveredDimIndex() {
        return this.m_hoveredDimIndex
    }

    // Access to Leverandorer
    GetLeverandorer() {
        Assert(this.m_leverandorer != undefined, "ExtData.GetLeverandorer - content is undefined.")
        return this.m_leverandorer
    }

    // Access to Varebeskrivelse
    GetVarebeskrivelse() {
        return this.m_varebeskrivelse
    }

    // This algorithm will look through the suppliers and unit options and select the most relevant combination as default 
    DirectSubChoise(owningArticle: ArticleGW) {
        var highestScore = -1 // the highest measured score for any combination so far
        var topSupply = -1 // the Leverantør index for the highscore
        var topUnit = -1 // the unit(pakke) index for the highscore
        var currentScore:number

        var thisLev: any = null
        var thisPak: {
            amount: number,
            pakningNr: number,
            pakningKlasse: number,

            pakningsEnhet: {
                id: string,
                beskrivelse: string
            },

            erPrisEnhet: boolean,
            erPSE: boolean,
            kalkulertInnhold: number,

            bestarAv: {
                antall: number,

                enhet: {
                    id: string,
                    beskrivelse: string
                }
            },

            gtin: string,
            gtinType: number,

            pakningsMal: [{
                bredde: number,
                lengde: number,
                hoyde: number,
                vekt: number,
                volum: number,
                type: number
            }] | null,

            lagerfort: boolean,
            bestillbar: boolean
        }

        const localEanNo = owningArticle.GetLocalEanNo()

        // Adding the price unit as an additional package type if no package type has a corresponding id as the article's price unit has
        for (var lev = 0; lev < this.GetLeverandorer().length; lev++) {
            if (this.CompareNumStrings(owningArticle.GetNobbOwner(), this.GetLeverandorer()[lev].deltagerNr) == true) {
                // found the right supplier, now let's check if it also has a suitable package for the price unit..
                var foundGoodPackage = false
                for (var pak = 0; pak < this.GetLeverandorer()[lev].pakninger.length; pak++) {
                    if (owningArticle.GetLocalUnit() == this.GetLeverandorer()[lev].pakninger[pak].pakningsEnhet.id) {
                        foundGoodPackage = true
                        break
                    }
                }

                if (foundGoodPackage == false) {

                    thisPak = {
                        amount: 0,
                        pakningNr: 0,
                        pakningKlasse: 0,
                        pakningsEnhet: {
                            id: owningArticle.GetLocalUnit(),
                            beskrivelse: owningArticle.GetPackageUnit()
                        },
                        erPrisEnhet: true,
                        erPSE: false,
                        kalkulertInnhold: 1.0,
                        bestarAv: {
                            antall: 1,
                            enhet: {
                                id: owningArticle.GetLocalUnit(),
                                beskrivelse: owningArticle.GetPackageUnit()
                            }
                        },
                        gtin: "",
                        gtinType: 0,
                        pakningsMal: null,
                        lagerfort: false,
                        bestillbar:false
                    }

                    thisPak.pakningsMal = null

                    this.GetLeverandorer()[lev].pakninger.push(thisPak)
                }

                break
            }
        }
        
        for (var lev = 0; lev < this.GetLeverandorer().length; lev++) {
            for (var pak = 0; pak < this.GetLeverandorer()[lev].pakninger.length; pak++) {
                thisLev = this.GetLeverandorer()[lev]
                thisPak = thisLev.pakninger[pak]
                currentScore = 0

                // Checking if the supplier ID matches the nobb owner, which typically means the supplier is 
                // the one intended by the author of the price book, this will have the greatest effect on the score.
                if ( this.CompareNumStrings( owningArticle.GetNobbOwner() , this.GetLeverandorer()[lev].deltagerNr) == true) {
                    currentScore += 20000
                }

                // The pre chosen package type for the article should dictate the choise of default 
                // package if there is one(or more) matching package ID
                if (owningArticle.GetLocalUnit() == thisPak.pakningsEnhet.id) {
                    currentScore += 9000
                }

                // Checking if the package type has the FPAK flag set, communicating that this is the 
                // smallest purchasable package type. This strongly directs the choise of default type
                if (this.GetLeverandorer()[lev].pakninger[pak].pakningKlasse != null) {
                    if (this.GetLeverandorer()[lev].pakninger[pak].pakningKlasse % 1 == 1) {
                        currentScore += 2500
                    }
                }

                // Same gtin as the article's eanNo?
                if (thisPak.gtin != null) {
                    if (thisPak.gtin != "") {
                        if (thisPak.gtin == owningArticle.GetLocalEanNo()) {
                            currentScore += 1500
                        }
                    }
                }
                
                if (thisPak.lagerfort == true) {
                    currentScore += 99
                }
                
                if (thisPak.bestillbar == true) {
                    currentScore += 84
                }
                
                if (thisPak.pakningsMal != null) {
                    currentScore += (thisPak.pakningsMal.length *9)
                }
                
                if (thisLev.medier != null) {
                    for (var i = 0; i < thisLev.medier.length; i++) {
                        currentScore += 11
                        if (thisLev.medier[i].mediaType == "PB") {
                            currentScore += 95
                        }
                    }
                }

                if (currentScore > highestScore) {
                    highestScore = currentScore
                    topSupply = lev
                    topUnit = pak
                }
            }
        }

        this.SetValgtLeverantorIndex(topSupply)
        this.SetValgtPakkeIndex(topUnit)
        this.SetActivePakkeIndex(topUnit)
    }

    GetFpakUnitFullString(article:ArticleGW) {
        if (this.m_fpakUnitFull == "(ukjent)") {
            this.GetFpakUnit(article)
        }

        return this.m_fpakUnitFull
    }

    GetFpakUnitId(article: ArticleGW) {
        if (this.m_fpakUnitId == "(ukjent)") {
            this.GetFpakUnit(article)
        }

        return this.m_fpakUnitId
    }

    GetFpakUnitDescription(article: ArticleGW) {
        if (this.m_fpakUnitDescription == "(ukjent)") {
            this.GetFpakUnit(article)
        }

        return this.m_fpakUnitDescription
    }

    CompareNumStrings(original: string, compared: string) {
        // simple comparation
        if (original == compared) {
            return true
        }

        // Reducing '0' signs at beginning on both strings
        var original_II = ""
        var oriStarted = false
                
        for (var or = 0; or < original.length; or++) {
            if (original.charAt(or) == "0") {
                if (oriStarted == true) {
                    original_II += original.charAt(or)
                }
            }
            else {
                oriStarted = true
                original_II += original.charAt(or)
            }
        }

        var compared_II = ""
        var compStarted = false
        
        for (var co = 0; co < compared.length; co++) {
            if (compared.charAt(co) == "0") {
                if (compStarted == true) {
                    compared_II += compared.charAt(co)
                }
            }
            else {
                compStarted = true
                compared_II += compared.charAt(co)
            }
        }

        if (original_II == compared_II) {
            return true
        }

        return false
    }
    
    // Returns the ean for a specific package type
    GetSpecificEan() {
        if (this.m_leverandorer == undefined) {
            return
        }

        const pakke = this.m_leverandorer[this.GetValgtLeverantorIndex()].pakninger[this.GetValgtPakkeIndex()];
        console.log(pakke);
        const ean = pakke.gtin;

        if (ean == null) {
            return ""
        }
        else {
            return ean
        }
    }

    medier: [{
        mediaType: string,
        url: string
    }]

    MergeAmount(externData: ExtDataGW) {
        if (this.m_leverandorer == undefined) {
            return
        }

        Assert(externData != null, " ExtData.MergeAmount - the incoming extended data was a null reference!")

        var pakke = -1, leverandor = "" // Pakke, leverantør
        var added: number = 0

        // First taking the added amount's specifics 
        for (var l = 0; l < externData.m_leverandorer.length; l++) {
            for (var p = 0; p < externData.m_leverandorer[l].pakninger.length; p++) {
                added = externData.m_leverandorer[l].pakninger[p].amount
                pakke = p
                leverandor = externData.m_leverandorer[l].deltagerNr
                break
            }
        }

        Assert(pakke != -1, "ExtData.MergeAmount - the added extData did not have any subgroup with any amount in it")
        // Now let's locate the corresponding value within the target article's ext data
        
        externData.m_leverandorer[0].pakninger[0].amount
    }

    public SetIsDefault(def: boolean) {
        this.m_isDefaultDataForArticlesMissingNobbNumber = def
    }

    public GetIsDefault() {
        return this.m_isDefaultDataForArticlesMissingNobbNumber == true
    }

    // Member variables for ExtDataGW:
    private m_nobbNr: number // The NOBB number of this article, recieved as a number
    private m_nobbModulNr: number // The NOBB-module number of this article, recieved as a number
    private m_varetype: number // The type code for this article
    private m_vareTekst1: string // 1/2 Short descriptional texts
    private m_vareTekst2: string // 2/2 Short descriptional texts
    private m_langVaretekst: string // A descriptional text that can be a bit longer than the vareText1,2 above
    private m_produsentVareNr: string // producer ware's number
    private m_lagerfort: boolean // True if this article is in storage presently

    // These stings describes a selectable unit
    private m_prisEnhet: { 
        id: string, // Very short (like 3 etters at most), for example "PAK"
        beskrivelse: string // This explains the ID (above) in a non shortened word, for example "Pakke"
    }

    private m_varebeskrivelse: string // A text describing this article that can be several rows long.

    private m_valgtLeverantorIndex: number // This variable tells what supplier is currently selected within the extended info view
    private m_hoveredLeverantorIndex: number // This variable tells what supplier is currently hovered (if any, otherwise it has the vallue -1) within the extended info view
    private m_valgtPakkeIndex: number // This variable tells what package unit is currently selected within the extended info view
    private m_hoveredPakkeIndex: number // This variable tells what package unit is currently hovered within the extended info view
    private m_activePakkeIndex: number // The index of the latest package that was typed into on an amount control (or just clicked in the inpout, or chosen by default)
    private m_valgtDimIndex: number /* This variable tells what dimension index is currently selected within the extended info view, note that this array of
                                  * options is most commonly not used apart from the first index [0], but if the array of possible dimension sets for the unit
                                  * would be greater than one, then these options would appear as selectables, much like the supplier or unit can be selected. */
    private m_hoveredDimIndex: number // This variable tells what dimension index is currently hovered within the extended info view
    private m_hoveredMediaLink: number // This variable tells what dimension index is currently hovered within the extended info view
    private m_hoveredProductImage: boolean // tells if the product image should be shown with dark borders and a message telling that a click will show a larger image
    private m_fpakUnitId: string // Short name of the smallest orderable package unit
    private m_fpakUnitDescription: string // Long name of the smallest orderable package unit
    private m_fpakUnitFull: string // Combined name of the smallest orderable package unit

    private m_isDefaultDataForArticlesMissingNobbNumber: boolean // This replacement of ordinary Ext Data is used when loading of ext data failed for an article,
                                                                 // and will cause info to be shown about the missing data where otherwise nobb info would have been displayed

    private m_selectionLabel: string // This string is given by the related article, it will be compared to see if this extData belongs to it or not

    // Leverandorer is an array of suppliers, each holding info and an array of possible package units with content data.
    private m_leverandorer: [{
        deltagerNr: string,
        navn: string,
        erVareeier: boolean,
        vareNummer: string,

        pakninger: [{
            amount: number,
            pakningNr: number,
            pakningKlasse: number,

            pakningsEnhet: {
                id: string,
                beskrivelse: string
            },

            erPrisEnhet: boolean,
            erPSE: boolean,
            kalkulertInnhold: number,

            bestarAv: {
                antall: number,

                enhet: {
                    id: string,
                    beskrivelse: string
                }
            },

            gtin: string,
            gtinType: number,

            pakningsMal: {
                bredde: number,
                lengde: number,
                hoyde: number,
                vekt: number,
                volum: number,
                type: number
            }[] | null,

            lagerfort: boolean,
            bestillbar: boolean
        }]
        
        medier: [{
            mediaType: string,
            url: string
        }]
    }]

    private m_vareGruppeNr: string // This value is the nobb group of this item
}



// WEBPACK FOOTER //
// ./client/view/ExtDataGW.tsx